<template>
    <div>
        <main-object
            v-bind:headline="headline"
            v-bind:levels="levels"
            v-bind:priceType="priceType"
            v-bind:providerType="providerType"
            v-bind:show-filters="showFilters"
            v-bind:filter-start-end-keys="filterStartEndKeys"
            v-on:openForm="openPriceForm"
            @openEditTable="openEditTable"
            ref="mainObject"
        />
        <item-form ref="form" v-on:submit="handleSubmit" v-bind:provider-type="providerType"/>
        <edit-table ref="editTable" :provider-type="providerType" v-on:submit="handleSubmit"></edit-table>
    </div>



</template>

<script>

import Mixin from '../tab';
import PriceMixin from './mixins'
import ItemForm from './Forms/Hotel';
import MainObject from "@components/CRUD/Item/Tabs/ProviderPrices/Main";
import moment from "moment";
import EditTable from "@components/CRUD/Item/Tabs/ProviderPrices/Forms/HotelEditTable.vue";



export default {
    mixins: [ Mixin, PriceMixin ],

    components: {EditTable, MainObject, ItemForm},

    data: function () {
        return {
            headline: 'Preise für die Hotelübernachtung',
            levels: ['level', 'board', 'priceGroup', 'Price'],
            priceType: 'hotel',
            providerType: 'agency',
            showFilters: {
                'timePeriods.startAt[before]': '',
                'timePeriods.endAt[after]': '',
                board: "",
                area: ""
            },
            filterStartEndKeys: ['timePeriods.endAt[after]', 'timePeriods.startAt[before]'],
        }
    },


}
</script>
